import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import CommonService from "../../services/common.service";
import Loader from "../Common/Loader";
import ReactHtmlParser from "react-html-parser";
import Slider from "react-slick";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const FeatureDetail = () => {
  const [data, setData] = useState({});
  const [featuresList, setFeaturesList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sliderImageArr, setSliderImageArr] = useState([]);
  let params = useParams(); // calling the hook
  var id = params.id;
  const firstApiResponseRef = useRef(null);

  useEffect(() => {
    setIsLoading(true);
    CommonService.getFeatureDetail(id)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setSliderImageArr(res.imagArr);
          setIsLoading(false);
          firstApiResponseRef.current = res;
        }
      })
      .then(() => {
        CommonService.getFeaturePageData(
          firstApiResponseRef.current.data?.type
        ).then((res) => {
          setFeaturesList(res.data);
        });
      });
  }, [id]);

  const [lightboxIsOpen, setLightboxIsOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [currentItem, setCurrentItem] = useState(null);
  const openLightbox = (imageIndex) => {
    setSelectedImageIndex(imageIndex);
    setCurrentItem(data);
    setLightboxIsOpen(true);
  };

  const closeLightbox = () => {
    setLightboxIsOpen(false);
  };

  var settings = {
    centerMode: true,
    centerPadding: 0,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>{data?.title}</h2>
            </div>
            <div className="tab-content">
              <div className="backbtn">
                <Link to={"/features"} className="btn btn-primary">
                  <i className="fas fa-arrow-left"></i>
                  {data.type === 2 && "Member Features"}
                  {data.type === 1 && "Admin Features"}
                </Link>{" "}
              </div>
              <div className="blogsection">
                <div className="left-blog">
                  <div className="bloglist">
                    <div className="blogbox noborder">
                      <figure>
                        <Link onClick={(e) => e.preventDefault()}>
                          <img
                            width={50}
                            height={50}
                            src={`${process.env.REACT_APP_UPLOAD_URL}feature_images/${data?.primary_image}`}
                            alt="img"
                          />
                        </Link>
                      </figure>
                      {sliderImageArr.length > 0 && (
                        <div className="vertical-center-3 testimonial">
                          <Slider {...settings}>
                            {data.secondary_image &&
                              JSON.parse(data.secondary_image).map(
                                (value, index) => (
                                  <div
                                    className="clublogo"
                                    key={index}
                                    onClick={() => openLightbox(index)}
                                  >
                                    <figure>
                                      <img
                                        src={`${process.env.REACT_APP_UPLOAD_URL}feature_images/${value}`}
                                        alt={`Secondary Imagesd ${index}`}
                                      />
                                    </figure>
                                  </div>
                                )
                              )}
                          </Slider>
                        </div>
                      )}
                      <div className="blogcontent">
                        <div className="date">
                          {/* <ul className="sponsor-social">
                            <li>
                              <a href="">
                                <i className="fab fa-facebook-f"></i>
                              </a>
                            </li>
                            <li>
                              <a href="">
                                <i className="fab fa-twitter"></i>
                              </a>
                            </li>
                            <li>
                              <a href="">
                                <i className="fab fa-linkedin-in"></i>
                              </a>
                            </li>
                            <li>
                              <a href="">
                                <i className="fab fa-instagram"></i>
                              </a>
                            </li>
                          </ul> */}
                        </div>
                        <h3>
                          <Link onClick={(e) => e.preventDefault()}>
                            {data?.title}
                          </Link>
                        </h3>
                        {ReactHtmlParser(data.long_description)}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="right-blog">
                  <div className="related-blog">
                    {data.type === 2 && <h3>Member Features</h3>}
                    {data.type === 1 && <h3>Admin Features</h3>}

                    <ul>
                      {featuresList &&
                        featuresList
                          .filter((currentData) => currentData.id !== data.id)
                          .map((item, key) => (
                            <li>
                              <Link to={`/feature-details/${item.id}`}>
                                {item?.title}
                              </Link>
                            </li>
                          ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {lightboxIsOpen && currentItem && (
        <Lightbox
          mainSrc={`${process.env.REACT_APP_UPLOAD_URL}feature_images/${
            JSON.parse(currentItem.secondary_image)[selectedImageIndex]
          }`}
          nextSrc={`${process.env.REACT_APP_UPLOAD_URL}feature_images/${
            JSON.parse(currentItem.secondary_image)[
              (selectedImageIndex + 1) %
                JSON.parse(currentItem.secondary_image).length
            ]
          }`}
          prevSrc={`${process.env.REACT_APP_UPLOAD_URL}feature_images/${
            JSON.parse(currentItem.secondary_image)[
              (selectedImageIndex +
                JSON.parse(currentItem.secondary_image).length -
                1) %
                JSON.parse(currentItem.secondary_image).length
            ]
          }`}
          onCloseRequest={closeLightbox}
          onMovePrevRequest={() =>
            setSelectedImageIndex(
              (selectedImageIndex +
                JSON.parse(currentItem.secondary_image).length -
                1) %
                JSON.parse(currentItem.secondary_image).length
            )
          }
          onMoveNextRequest={() =>
            setSelectedImageIndex(
              (selectedImageIndex + 1) %
                JSON.parse(currentItem.secondary_image).length
            )
          }
        />
      )}
    </>
  );
};

export default FeatureDetail;
